import firebase from 'firebase/app'
import 'firebase/functions'
import { BugReport, Billing, ContactSupport } from './types/user'

type Result = firebase.functions.HttpsCallableResult

export const startWorkstation = async (uuid: string): Promise<Result> => {
  const func = firebase.functions().httpsCallable('workstations-startWorkstation')
  return func({ uuid })
}

export const stopWorkstation = async (uuid: string): Promise<Result> => {
  const func = firebase.functions().httpsCallable('workstations-stopWorkstation')
  return func({ uuid })
}

export const adminGetAllUsers = async (): Promise<Result> => {
  const func = firebase.functions().httpsCallable('admin-getAllUsers')
  return func()
}

export const setupBillingCustomer = async ({ billing }: { billing: Billing }): Promise<Result> => {
  const func = firebase.functions().httpsCallable('payments-setupBillingCustomer')
  return func({ billing })
}

export const refreshPaymentMethod = async (paymentMethodId: string): Promise<Result> => {
  const func = firebase.functions().httpsCallable('payments-refreshPaymentMethod')
  return func({ paymentMethodId })
}

export const listCustomerInvoices = async (): Promise<Result> => {
  const func = firebase.functions().httpsCallable('payments-listCustomerInvoices')
  return func()
}

export const reportBug = async (report: BugReport): Promise<Result> => {
  const func = firebase.functions().httpsCallable('users-reportBug')
  return func(report)
}

export const contactSupport = async (report: ContactSupport): Promise<Result> => {
  const func = firebase.functions().httpsCallable('users-contactSupport')
  return func(report)
}